import React from 'react';
// import DigitalPassive from '../../../public/automotive_image/commercial_Digital_Passive_Components_relative.svg';
// import PowerConversion from '../../../public/automotive_image/commercial_Power_Conversion_AC_DC_relative.svg';
// import TractionInverter from '../../../public/automotive_image/commercial_Traction_Inverter_Motor_Generator_relative.svg';
import { FullscreenSvg, ThirdLayerImageProps } from '../automotivePage/CarImageComponent';

const LowVoltDcImage: React.FC<ThirdLayerImageProps> = ({ onBack }) => {
    return (
        <FullscreenSvg
            svgUrl={'/automotive_image/commercial_Digital_Passive_Components_relative.svg'}
            onBack={onBack}
        />
    );
};

const TractionInverterImage: React.FC<ThirdLayerImageProps> = ({ onBack }) => {
    return (
        <FullscreenSvg
            onBack={onBack}
            svgUrl={'/automotive_image/commercial_Traction_Inverter_Motor_Generator_relative.svg'}
        />
    );
};

const PowerConversionImage: React.FC<ThirdLayerImageProps> = ({ onBack }) => {
    return (
        <FullscreenSvg
            svgUrl={'/automotive_image/commercial_Power_Conversion_AC_DC_relative.svg'}
            onBack={onBack}
        />
    );
};

export { LowVoltDcImage, TractionInverterImage, PowerConversionImage };
